import { motion } from "framer-motion";
import React, { FC } from "react";
import SafeImage from "components/SafeImage/SafeImage";
import { TaxonomyType } from "data/types";
import { Link } from "react-router-dom";
import { cardHover } from "utils/motionPresets";

export interface CardCategory4Props {
  className?: string;
  taxonomy: TaxonomyType;
}

const CardCategory4: FC<CardCategory4Props> = ({
  className = "",
  taxonomy,
}) => {
  const { name, thumbnail, id } = taxonomy;
  return (
    <motion.div
      initial="rest"
      whileHover="hover"
      animate="rest"
      variants={cardHover}
      className={className}
    >
      <Link
        to={id.toString()!}
        className="nc-CardCategory4 flex flex-col bcr-card-modern p-2 sm:p-3 h-full"
        data-nc-id="CardCategory4"
      >
        <div className="flex-shrink-0 relative w-full aspect-[4/3] max-h-[160px] rounded-xl overflow-hidden group">
          <SafeImage
            src={thumbnail}
            alt={name}
            placeholderVariant="default"
            placeholderCompact
            objectFit="cover"
            imgClassName="group-hover:scale-105 transition-transform duration-500"
          />
          <span className="opacity-0 group-hover:opacity-100 absolute inset-0 bg-gradient-to-t from-primary-900/50 to-transparent transition-opacity duration-300" />
        </div>
        <div className="mt-3 px-1 text-center">
          <h2 className="text-sm sm:text-base text-neutral-900 dark:text-neutral-100 font-semibold line-clamp-2 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors">
            {name}
          </h2>
        </div>
      </Link>
    </motion.div>
  );
};

export default CardCategory4;
